import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07af5105"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: /*#__PURE__*/_normalizeClass(['base-input'])
}
const _hoisted_2 = ["for"]
const _hoisted_3 = { class: "base-input__wrapper" }
const _hoisted_4 = ["id", "value", "type", "placeholder", "disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          class: _normalizeClass(['base-input__label']),
          for: _ctx.id
        }, _toDisplayString(_ctx.label), 9, _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("input", {
        id: _ctx.id,
        value: _ctx.modelValue,
        class: _normalizeClass(['base-input__input']),
        type: _ctx.type,
        placeholder: _ctx.placeholder,
        disabled: _ctx.disabled,
        onBlur: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('blur', $event.target.value))),
        onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value))),
        onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value)))
      }, null, 40, _hoisted_4)
    ])
  ]))
}